import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { Options, Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';
import { SurveyAnswerService } from '../../public-api';
import * as moment_ from 'moment';

const moment = moment_;

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css']
})
export class DateComponent implements OnInit {

  @ViewChild("MyProp") MyProp: ElementRef;

  response: string = ""
  show: boolean = false;
  panelOpenState = true;
  timer: any;

  @Input() Question: Question;
  @Input() SurveyBase: Survey

  startDate: any;
  endDate: any;
  date: any;


  questiondsIdLinks: number[] = [];
  questions: Question[] = [];
  result: Question;
  popupService: PopupService;
  option: Options;

  constructor(private _adapter: DateAdapter<any>, private dialog: MatDialog, private surveyService: SurveyAnswerService) {
    this.french();

  }

  french() {
    this._adapter.setLocale('fr');
    moment.locale('fr');
  }

  ngOnInit(): void {
    this.popupService = new PopupService(this.dialog);
    this.option = this.Question.options[0];

    if (this.option.result) {
      this.treatEditSurvey(this.SurveyBase);
    }
  }

  searchLink() {

    if (this.timer != null) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000);


    if (this.Question.displayDateMode == 3 && this.date) {
      this.option.result = this.formatDate(this.date);
      this.response = this.formatDate(this.date);
      this.show = true;

      if (this.option.links) {
        this.handleLinks();
      }

    } else if (this.Question.displayDateMode == 4 && this.endDate && this.startDate) {
      if (this.endDate > this.startDate) {
        this.response = this.formatDateRange(this.startDate, this.endDate);
        this.Question.result = this.formatDateRange(this.startDate, this.endDate);
        this.option.result = moment(this.startDate).format('L') + ";" + moment(this.endDate).format('L');
        this.show = true

        if (this.option.links) {
          this.handleLinks();
        }
      } else {
        this.response = "Dates Invalides"
      }
    }
  }

  /** TODO : Voir pour réutilier cet élément duppliqué dans chaque composant... */
  handleLinks() {
    this.questiondsIdLinks = [];
    this.questions = [];

    this.option.links.forEach(element => {
      element.questionDestinationId;
      this.questiondsIdLinks.push(element.questionDestinationId);

      /**Open popup */
      if (element.popupDestinationId != null) {
        this.popupService.openPopupDialog(element.popupDestinationId, this.SurveyBase);
      }

      /**open tip */
      if (element.tipDestinationTipId != null) {
        this.popupService.openTipDialog(element.tipDestinationTipId);
      }
    });

    this.questiondsIdLinks.forEach(element => {
      this.result = this.SurveyBase.questions.find(x => x.id == element);
      if (this.result) {
        this.questions.push(this.result);
      }
    });
  }

  /** TODO : service pour gérer l'edit de tous les composants ? */
  treatEditSurvey(survey) {
    this.panelOpenState = false;
    this.show = true;

    this.option.links.forEach(element => {
      this.questiondsIdLinks.push(element.questionDestinationId);
    });

    this.questiondsIdLinks.forEach(element => {
      this.result = this.SurveyBase.questions.find(x => x.id == element);
      if (this.result) {
        this.panelOpenState = false;
        this.questions.push(this.result);
        this.show = true;
      }
    });

    if (this.Question.displayDateMode == 3) {
      this.date = moment(this.option.result, 'DD/MM/YYYY');
      this.response = this.formatDate(this.date);
    }
    else if (this.Question.displayDateMode == 4) {
      var dateArray = this.option.result.split(';');
      this.startDate = moment(dateArray[0], 'DD/MM/YYYY'); moment().toDate();
      this.endDate = moment(dateArray[1], 'DD/MM/YYYY'); moment().toDate();
      this.response = this.formatDateRange(this.startDate, this.endDate);
    }
  }

  getDateObject(date:string) {
    var momObj = moment(this.option.result, 'DD/MM/YYYY');
    return new Date(momObj.year(), momObj.month(), momObj.date());
  }

  formatDate(date: Date) {
    return moment(date).format('L');
  }

  formatDateRange(startDate: Date, endDate: Date) {
    return moment(startDate).format('L') + ' - ' + moment(endDate).format('L');
  }
}
